import { render, staticRenderFns } from "./IconSendPlaneAlt.vue?vue&type=template&id=77324dfa&"
import script from "./IconSendPlaneAlt.vue?vue&type=script&lang=js&"
export * from "./IconSendPlaneAlt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports